import { useEffect } from "react";

/**
 * Updates document title, meta description, canonical, and OG tags per route.
 * Call once at the top of each page component.
 */
export function usePageMeta({ title, description, path = "" }) {
  useEffect(() => {
    const baseUrl = "https://www.atengksarap.online";
    const canonical = `${baseUrl}${path || ""}`;

    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [attrName, attrVal] = selector
          .replace(/[[\]"']/g, "")
          .replace("meta", "")
          .split("=");
        el.setAttribute(attrName, attrVal);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }

    setMeta('meta[property="og:url"]', "content", canonical);

    // canonical link
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonical;
  }, [title, description, path]);
}
